import PropTypes from 'prop-types';

import IconComponent from 'Component/Icon';

/** @namespace Bodypwa/Component/FacebookIcon/Component */
export class FeaturedIconComponent extends IconComponent {
    static propTypes = {
        size: PropTypes.string.isRequired,
        color: PropTypes.string.isRequired
    };

    render() {
        const { dimensions, colors } = this;
        const { size, color } = this.props;
        return (
            <svg
                width={ dimensions[size] }
                height={ dimensions[size] }
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path d="M5.78334 14.8L4.53334 12.7333L2.18334 12.2L2.4 
                    9.79995L0.800003 7.99995L2.4 6.19995L2.18334 3.79995L4.53334
                    3.26662L5.78334 1.19995L8 2.14995L10.2167 1.19995L11.4667 
                    3.26662L13.8167 3.79995L13.6 6.19995L15.2 7.99995L13.6 9.79995L13.8167 12.2L11.4667 12.7333L10.2167 
                    14.8L8 13.85L5.78334 14.8ZM6.26667 13.2833L8 12.55L9.73334 13.2833L10.7 
                    11.6666L12.5333 11.25L12.3667 9.39995L13.6 7.99995L12.3667 6.59995L12.5333 
                    4.74995L10.7 4.33328L9.73334 2.71662L8 3.44995L6.26667 2.71662L5.3 4.33328L3.46667
                    4.73328L3.63334 6.59995L2.4 7.99995L3.65 9.39995L3.46667 11.2666L5.3 11.6833L6.26667 
                    13.2833ZM7.15 10.4L11.1167 6.44995L10.2667 5.59995L7.15 8.69995L5.73334 7.29995L4.88334 
                    8.14995L7.15 10.4Z"  fill={ colors[color] } />
            </svg>

        );
    }
}
export default FeaturedIconComponent;
